/** Promotional access is credit-limited, not a time-limited free trial. */
export function subscriptionPresentation(sub: { metadata?: unknown; renewsAt?: unknown; status: string }) {
  const isPromo = (sub.metadata as { promo?: unknown } | null)?.promo === true;
  return { isPromo, renewsAt: isPromo ? null : sub.renewsAt, status: sub.status };
}

export function subscriptionPlanLabel(plan: { name: string; status?: string; isPromo?: boolean }): string {
  if (plan.isPromo) return `${plan.name} plan — Promotion`;
  return plan.status === 'trialing' ? `Free trial — ${plan.name} plan` : `${plan.name} plan`;
}

/** Display whole credits while preserving fractional accounting underneath. */
export function formatCreditCount(value: number): string {
  return Math.floor(Number.isFinite(value) ? value : 0).toLocaleString();
}
